import { KeyboardArrowRight } from "@mui/icons-material";
import { Box } from "@mui/material";
import "../styles/samplePromptBox.css";

type SamplePromptBoxProps = {
    sample: {
        prompt: string;
        logos: string[];
    };
    initiateWorkflow: (prompt: string) => void;
};

const SamplePromptBox: React.FC<SamplePromptBoxProps> = ({sample, initiateWorkflow}) => {
    return <Box sx={{ border: "1px solid #ECEDF1", borderRadius: 2, background: "#fff", height: "100%", display: "flex", flexDirection: "column", fontSize: 12 }}>
        <Box sx={{ padding: "8px", display: "flex" }}>
            {sample?.logos?.map((logo, index) => {
                return <img src={logo} alt={"app icon"} className="samplePromptLogo" key={logo+index} />
            })}
        </Box>
        <Box sx={{ color: "#536074", padding: "8px 8px 16px", flex: 1 }}>
            {sample.prompt}
        </Box>
        <Box
            sx={{
                paddingTop: 2,
                borderTop: "1px solid #ECEDF1",
                padding: "10px 8px",
                color: "#546FFF",
                display: "flex",
                alignItems: "center",
                cursor: "pointer",
                fontWeight: "500",
            }}
            onClick={() => initiateWorkflow(sample.prompt)}
        >
            Run prompt
            <KeyboardArrowRight sx={{ fontSize: 18 }} />
        </Box>
    </Box>
}

export default SamplePromptBox;